import SubcategoryPage from '@/components/template/SubcategoryPage';

const Elegance = () => {
  const products = [
    {
      title: "Elegance Omarica",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/omarica"
    },
    {
      title: "Elegance Polica",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/polica"
    },
    {
      title: "Elegance Ogledalo",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/ogledalo"
    },
    {
      title: "Elegance Komoda",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/komoda"
    },
    {
      title: "Elegance Stol",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/stol"
    },
    {
      title: "Elegance Set",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/pohistvo/elegance/set"
    }
  ];

  return (
    <SubcategoryPage
      title="Kolekcija Eleganca"
      description="Raziskujte našo kolekcijo elegantnih kosov pohištva, ki združujejo estetsko privlačnost in funkcionalnost. Naši izdelki so zasnovani za sodobne prostore in ponujajo čist, eleganten videz."
      heroImage="https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Elegance;